<template>
    <page>
        <module title="健康活动详情">
            <div v-if="activityInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="活动标题">{{activityInfo.title}}</c-detail-item>

                    <c-detail-item label="报名截止时间">{{activityInfo.apply_deadline}}</c-detail-item>

                    <c-detail-item label="报名人数上限">{{activityInfo.user_count}}</c-detail-item>

                    <c-detail-item label="已报名人数">{{activityInfo.record_count}}</c-detail-item>

                    <c-detail-item label="活动封面图">
                        <template v-slot="{data}">
                            <c-image :src="activityInfo.cover_image" preview size="50" style="margin-right: 10px;"></c-image>
                        </template>
                    </c-detail-item>

                    <c-detail-item label="活动状态">
                        <template v-slot="{data}">
                            <span v-if="activityInfo.state == 1" style="color:darkgreen">启用</span>
                            <span v-if="activityInfo.state == 2" style="color:red">禁用</span>
                        </template>
                    </c-detail-item>


                    <c-detail-item label="活动内容图片" full>
                        <template v-slot="{data}">
                            <div  class="flex-center-cross">
                                <c-image v-for="(item, i) in activityInfo.content_images.split(',')" :key="i" :src="item" size="50" preview style="margin-right: 10px;"></c-image>
                            </div>
                        </template>
                    </c-detail-item>

                    <c-detail-item label="创建人">{{activityInfo.create_user_realname}}</c-detail-item>
                    <c-detail-item label="创建时间">{{activityInfo.create_date}}</c-detail-item>

                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'offline_activity_detail',

        props: {
            id: String
        },

        components: {
            productInfo
        },

        data() {
            return {
                activityInfo: ''
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/offineActivity/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.activityInfo = data;
                    }
                });
          }
        }
    }
</script>